<template>
  <div class="changeStatus">
    <section>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        style="padding-bottom: 50px;"
        class="demo-ruleForm"
      >
        <li class="redText">
          注意：※为必填项
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 客厅温度：
          </div>
          <el-form-item class="input_right" prop="cewenKetingmp">
            <el-input placeholder="请输入客厅温度" style="width: calc(100% - 30px)" v-model="form.cewenKetingmp" type="text"/>℃
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 测温面积：
          </div>
          <el-form-item class="input_right" prop="cewenArea">
            <el-input placeholder="请输入测温面积" style="width: calc(100% - 30px)" v-model="form.cewenArea" type="text"/>m²
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 期望温度：
          </div>
          <el-form-item class="input_right" prop="cewenQwwd">
            <el-input placeholder="请输入期望温度" style="width: calc(100% - 30px)" v-model="form.cewenQwwd" type="text"/>℃
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 是否有老人小孩：
          </div>
          <el-form-item class="input_right" prop="cewenJy">
            <dict-select dict-code="isLr" is-constants v-model="form.cewenJy"/>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
             主卧温度：
          </div>
          <el-form-item class="input_right" prop="cewenZhuwomp">
            <el-input placeholder="请输入主卧温度" style="width: calc(100% - 30px)" v-model="form.cewenZhuwomp" type="text"/>℃
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
             次卧温度：
          </div>
          <el-form-item class="input_right" prop="cewenCiwomp">
            <el-input placeholder="请输入次卧温度" style="width: calc(100% - 30px)" v-model="form.cewenCiwomp" type="text"/>℃
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
             书房温度：
          </div>
          <el-form-item class="input_right" prop="cewenShufangmp">
            <el-input placeholder="请输入书房温度" style="width: calc(100% - 30px)" v-model="form.cewenShufangmp" type="text"/>℃
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
             厨房温度：
          </div>
          <el-form-item class="input_right" prop="cewenChufangmp">
            <el-input placeholder="请输入厨房温度" style="width: calc(100% - 30px)" v-model="form.cewenChufangmp" type="text"/>℃
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
             其他温度：
          </div>
          <el-form-item class="input_right" prop="cewenQitamp">
            <el-input placeholder="请输入其他温度" style="width: calc(100% - 30px)" v-model="form.cewenQitamp" type="text"/>℃
          </el-form-item>
        </li>
        <li>
          备注  <span class="redText" style="margin-left: 10px;"> 注意：描述上限为200字</span>
        </li>
        <el-input placeholder="备注" type="textarea" clearable :autosize="{ minRows: 6, maxRows: 6 }"
                  v-model.trim="form.cewenMemo" maxlength="200" show-word-limit/>
        <li>
          文件上传：
        </li>
        <div class="file">
          <input
            multiple="multiple"
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getIdHt"
          />文件上传
        </div>
        <div v-for="(item,ind) in imgHtList" :key="ind" class="imgDiv">
          <b @click="deleteHtId(ind)" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="">
        </div>
      </el-form>
    </section>
    <button  class="btn_bx" type='button' @click.stop="changeStatus">
      提 交
    </button>
  </div>
</template>

<script>
  import {findArea, getCaptcha, getUser, saveCw, saveMjfg, saveMjtg} from "@/api";
  import { Popup } from 'mint-ui';
  export default {
    data() {
      return {
        value: [],
        options: [],
        form: {
          cewenJy: '否'
        },
        rules: {
          cewenKetingmp: [{
            required: true, message: '必填'
          }],
          cewenArea: [
            {
              required: true, message: '必填'
            }
          ],
          cewenQwwd: [
            {
              required: true, message: '必填'
            }
          ],
          name: [{
            required: true, message: '必填'
          }],
          address: [
            {
              required: true, message: '必填'
            }
          ],
          lnbt: [
            {
              required: true, message: '必填'
            }
          ],
          captcha: [
            {
              required: true, message: '必填'
            }
          ],
        },
        fileList: [],
        imgList: [],
        imageIdHt: true,
        imgHtList: [],
        imgHref: '',
        disabled: false,
      };
    },
    mounted() {
      // this.getUser()
    },
    methods: {
      getUser() {
        getUser({
          code: this.$route.query.code,
        }).then((res) => {
          this.$set(this.form,'address',res.data.address)
        });
      },

      getIdHt(e) {
        let fileList = e.target.files
        for(var i=0;i<fileList.length;i++){
          let file=fileList[i];                 /* 获取单个File对象 */
          this.fileList.push(file);
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {    //成功读取文件
            this.imgHtList.push(e.target.result)
          };
        }
        this.imageIdHt = false
      },
      deleteHtId(ind) {
        this.imgHtList.splice(ind, 1);
        this.fileList.splice(ind, 1)
        this.imageIdHt = true
      },
      getYzm() {
        var reg_tel = /^(1)\d{10}$/;
        if(!reg_tel.test(this.form.mobNo)) {
          this.$toast('请输入正确的手机号码')
          return
        }
        let params = {
          sysType: 1,
          phone: this.form.mobNo,
        }
        getCaptcha(params).then(res=>{
          if(res.code=='0000') {
            this.maxtime = 60
            this.disabled = true
            this.timer = setInterval(() => {
              this.CountDown()
            }, 1000)
          }
        })
      },
      CountDown() {
        if (this.maxtime > 0) {
          let seconds = this.maxtime;
          this.msg = +seconds + "s" + '后获取';
          --this.maxtime;
        } else {
          clearInterval(this.timer);
          this.msg = '获取验证码'
          this.disabled = false
        }
      },
      changeStatus() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            var formdata = new FormData();
            this.form.customerId = this.$route.query.userId
            this.form.code = this.$route.query.code
            for (let k in this.form) {
              formdata.append(k, this.form[k]);
            }
            this.fileList.map(file => {
              formdata.append("files", file);
            })
            saveCw(formdata).then(res => {
              if (res.code == '0000') {
                this.$toast("操作成功");
                this.$router.go(-1)
              }
            })
          }

        })

      },
      getXy() {
        this.xyFlag = true
      }
    }
    ,
  }
  ;
</script>

<style>
  .changeStatus {
    padding: 3%;
    min-height: 90%;
    background: #fff;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 90%;
  }
  .yzmBtn{
    border: 1px solid #C2E7B0;
    border-radius: 3px;
    line-height: 26px;
    background: #F0F9EB;
    color: #67C23A;
    font-size: 12px;
    /*background: #000;*/
  }
  .xy{
    background: #fff;
    height: 80vh;
    width: 90%;
    border-radius: 5px;
    overflow-y: auto;
    /*margin-left: 5%;*/
    padding: 5px;
  }
  .changeStatus .mint-cell-wrapper {
    font-size: 14px !important;
  }

  .changeStatus .buleText {
    color: #1E88C7;
    font-size: 12px;
  }

  .changeStatus v.mask {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .4);
  }

  .changeStatus .btn_bx {
    width: 100%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }

  header, footer {
    height: 60px;
    line-height: 60px;

    /*text-align:center;*/
  }

  header {
    margin-bottom: 5px;
    background-color: #fff;

  }

  section {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 100%;
    overflow: auto; /* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .sfzsl {
    width: 90%;
    height: 80vh;
    left: 5%;
    border-radius: 10px;
    position: absolute;
  }

  .redText {
    color: red;
  }

  .lable_left {
    width: 150px;
    color: black;
  }

  .flex_input {
    display: flex;
    line-height: 40px;
  }

  .changeStatus li {
    line-height: 40px;
    display: flex;
    border-bottom: 1px solid #F7F6F7;
  }

  .li_flex {
    justify-content: space-between;
  }

  .lable_right {
    color: #949393;
  }

  .greyText {
    color: #8c939d;
    margin-right: 10px;
  }

  .input_right {
    flex: 1;
    color: black;
  }
  .changeStatus .input_right input {
    width: calc(100% - 30px) !important
  }
  .changeStatus .el-input__inner {
    padding: 0 !important;
  }

  .changeStatus .input_right input, .input_right textarea {
    border: none;
    outline: none;
    float: 1;
    margin-top: 5px;
  }

  .changeStatus .el-form-item {
    margin-bottom: 0 !important;
  }

  .itemList {
    /* border-bottom: 1px solid #fcfcfc; */
    color: #646262;
    /* padding-left: 8%; */
  }

  /*.mint-cell-wrapper {*/
  /*  padding: 0 !important;*/
  /*}*/
  .item {
    /* border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px; */
  }

  .uploader-file {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .uploader-file:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: 178px;
    display: block;
    margin-top: 25px;
  }

  .file {
    width: 90%;
    height: 30px;
    position: relative;
    display: inline-block;
    background: #FBFDFF;
    border: 1px #C0CCDA dashed;
    border-radius: 4px;
    padding: 4px 12px;
    overflow: hidden;
    color: #1E88C7;
    text-decoration: none;
    text-indent: 0;
    text-align: center;
    line-height: 30px;
  }

  .file input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
  }

  .file:hover {
    background: #FBFDFF;
    border-color: #AADFFD;
    color: #004974;
    text-decoration: none;
  }

  .imgDiv {
    position: relative;
  }

  .error_icon {
    position: absolute;
    font-size: 25px;
    right: 0px;
    top: 0px;
    z-index: 999999;
    color: #f00;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/yhcw/index.vue